<script setup lang="ts">
  import { Dialog, Button, Text, IconBasketLarge } from "@ui-kit";
  import { itemUnsetZoneApi, ResponseCode } from "@src/api";

  const { item_id, zone_id, visible } = defineProps<{ item_id: string; zone_id: string; visible: boolean }>();
  const emit = defineEmits<{ (e: "close"): void; (e: "unlink"): void }>();

  const handleDelete = async () => {
    const result = await itemUnsetZoneApi({ item_id, zone_id });

    if (result.code === ResponseCode.OK) {
      emit("unlink");
      emit("close");
    }
  };
</script>

<template>
  <Dialog :isOpen="visible" :closeOnOutsideClick="false" @close="emit('close')">
    <div class="unlink-item-dialog" data-testid="unlink-item-dialog">
      <div class="unlink-item-dialog__content">
        <IconBasketLarge />
        <div class="unlink-item-dialog__content-description">
          <Text font="body-bold-18">{{ $t("Удалить товар") + "?" }}</Text>
          <Text font="body-regular-14">{{ $t("Это действие нельзя отменить") }}</Text>
        </div>
      </div>
      <div class="unlink-item-dialog__footer">
        <Button variant="negative" size="s" class="hold-button" data-testid="unlink-item-dialog-confirm-btn" @click="handleDelete">
          {{ $t("Удалить") }}
        </Button>
        <Button variant="secondary" size="s" @click="emit('close')" data-testid="unlink-item-dialog-cancel-btn">
          {{ $t("Отменить") }}
        </Button>
      </div>
    </div>
  </Dialog>
</template>

<style scoped>
  .unlink-item-dialog {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 328px;
    padding: 24px 20px 20px;
  }

  .unlink-item-dialog__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .unlink-item-dialog__content-description {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .unlink-item-dialog__footer {
    display: flex;
    flex-direction: column;
    gap: 8px;

    & :deep(.button) {
      width: 100%;
    }
  }
</style>
